import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Checkbox } from "../checkbox";
import { IconV2 } from "../../icon_v2";
/**
 * Override react-select's GroupHeading:
 *
 * Component that renders the data of a group.
 */
const GroupHeading = (props) => {
    var _a, _b;
    const { selectProps, data } = props;
    const { selectedIndidacatorInMenu, optionSelected } = selectProps;
    const { label, options } = data;
    const [selectAllCheckbox, setSelectAllCheckbox] = useState(false);
    const [selectAllIndeterminate, setSelectAllIndeterminate] = useState(false);
    const [isExpanded, setIsExpanded] = useState(selectProps.expandGroupOptions);
    // check if all options in the group have been selected
    const allOptionsSelected = () => {
        let allSelected = false;
        if (optionSelected) {
            allSelected = options.every((opt) => optionSelected.some((x) => opt.value === x.value));
        }
        return allSelected;
    };
    const handleSelectAll = () => {
        const vals = optionSelected !== null && optionSelected !== void 0 ? optionSelected : [];
        if (!allOptionsSelected()) {
            //select all!
            const newVals = [
                ...vals,
                ...props.data.options,
            ];
            selectProps.onChange(newVals, {
                action: "select-option",
                option: {
                    value: `select-eco-group-${label !== null && label !== void 0 ? label : "undefined"}`,
                    label: label !== null && label !== void 0 ? label : "undefined-group",
                },
            });
        }
        else {
            // deselect all
            const newVals = vals.filter((optSel) => !options.includes(optSel));
            selectProps.onChange(newVals, {
                action: "deselect-option",
                removedValues: options,
                option: {
                    value: `remove-eco-group-${label !== null && label !== void 0 ? label : "undefined"}`,
                    label: label !== null && label !== void 0 ? label : "undefined-group",
                },
            });
        }
    };
    const handleExpandGroupOptions = (props) => {
        var _a;
        setIsExpanded(!isExpanded);
        const groupHeadingElement = document.getElementById(props.id);
        const optionsDiv = (_a = groupHeadingElement === null || groupHeadingElement === void 0 ? void 0 : groupHeadingElement.parentElement) === null || _a === void 0 ? void 0 : _a.nextElementSibling;
        if (optionsDiv) {
            optionsDiv.classList.toggle("hidden");
        }
    };
    useEffect(() => {
        var _a;
        let allSelected = false, noneSelected = true;
        if (optionSelected) {
            allSelected = options.every((opt) => optionSelected.some((x) => opt.value === x.value));
            noneSelected = options.every((opt) => !optionSelected.some((x) => opt.value === x.value));
        }
        if (allSelected) {
            setSelectAllCheckbox(true);
            setSelectAllIndeterminate(false);
        }
        else if (noneSelected) {
            setSelectAllCheckbox(false);
            setSelectAllIndeterminate(false);
        }
        else {
            setSelectAllCheckbox(false);
            setSelectAllIndeterminate(true);
        }
        if (!selectProps.expandGroupOptions) {
            const groupHeadingElement = document.getElementById(props.id);
            const optionsDiv = (_a = groupHeadingElement === null || groupHeadingElement === void 0 ? void 0 : groupHeadingElement.parentElement) === null || _a === void 0 ? void 0 : _a.nextElementSibling;
            if (optionsDiv) {
                optionsDiv.classList.add("hidden");
            }
        }
    }, [optionSelected, options, selectProps.expandGroupOptions, props.id]);
    return (_jsxs("div", { className: "flex justify-between pl-2", children: [_jsx("button", { onClick: () => handleExpandGroupOptions(props), children: isExpanded ? (_jsx(IconV2, { type: "fa", icon: {
                        icon: ["far", "angle-up"],
                        fixedWidth: true,
                        size: "xl",
                    } })) : (_jsx(IconV2, { type: "fa", icon: {
                        icon: ["far", "angle-down"],
                        fixedWidth: true,
                        size: "xl",
                    } })) }), _jsxs("button", { className: `text-primaryText dark:text-dark-primaryText hover:bg-buttons-tertiary-bg-active hover:dark:bg-dark-buttons-tertiary-bg-active flex w-full flex-row
        ${selectedIndidacatorInMenu === "icon" && "justify-between"} 
        px-3 py-2`, id: props.id, onClick: () => handleSelectAll(), children: [selectedIndidacatorInMenu === "checkbox" ? (_jsx(_Fragment, { children: _jsx(Checkbox, { label: (_a = props.data.label) !== null && _a !== void 0 ? _a : "", hideLabel: true, checked: selectAllCheckbox, indeterminate: selectAllIndeterminate, value: (_b = props.data.label) !== null && _b !== void 0 ? _b : "" }) })) : (""), props.data.label, selectAllCheckbox && selectedIndidacatorInMenu === "icon" ? (_jsx(IconV2, { type: "fa", icon: {
                            icon: ["far", "check"],
                            fixedWidth: true,
                            size: "lg",
                        } })) : ("")] })] }));
};
export default GroupHeading;
